<template>
  <main>
    <div class="courses-page">
      <div class="section-frame">
        <ul class="breadcrumbs">
          <li>
            <router-link to="/"><i class="fa-home-line"></i></router-link>
          </li>
          <li><i class="fa-arrow-next"></i></li>
          <li>
            <router-link to="/courses"
              ><i>{{ $t("all_courses") }}</i></router-link
            >
          </li>
          <li v-if="course"><i class="fa-arrow-next"></i></li>
          <li v-if="course">
            <router-link :to="'/course/' + course.id">{{
              course.name
            }}</router-link>
          </li>
        </ul>
      </div>
      <div class="courses-main-info" v-if="course">
        <div class="section-frame">
          <div class="courses-main-content">
            <div class="page-sub-title sub-title-white courses-title">
              <h1>
                <i class="fa-title"></i>
                <i>{{ course.name }}</i>
                <span class="desc-lesson unset"
                  >{{ course.lessons_count }}{{ $t("lessons") }}</span
                >
              </h1>
              <span class="mob-counter-lesson unset"
                >{{ course.lessons_count }} {{ $t("lessons_upper") }}</span
              >
              <p>{{ course.category }}</p>
            </div>
            <div class="courses-data-frame">
              <p class="courses-main-data">
                <i class="fa-user"></i><span>{{ $t("author") }}: </span
                ><span>{{ course.author }}</span>
              </p>
            </div>
            <div class="courses-data-frame">
              <p class="courses-main-data">
                <i class="fa-clock"></i><span>{{ $t("last_update") }}:</span>
                <span>{{ course.last_update }}</span>
              </p>
              <p class="courses-main-data" v-if="course && course.person_count">
                <i class="fa-user"></i
                ><span>{{ $t("subscribers_count") }}: </span>
                <span> {{ course.person_count }}</span>
              </p>
            </div>

            <div class="courses-main-btn">
              <a href="#" v-if="hasWishlist" class="courses-save"
                ><span>{{ $t("saved") }}</span
                ><i class="fa-save"></i
              ></a>
              <a
                href="#"
                v-else
                class="courses-save"
                @click.prevent="pushWishlist(course.id)"
                ><span>{{ $t("save") }}</span> <i class="fa-save"></i
              ></a>
              <div class="courses-share">
                <p>
                  <span>{{ $t("share") }}:</span>
                </p>
                <ul v-if="course">
                  <li>
                    <FacebookButton
                      appID="887427962119815"
                      btn-text=""
                      style="
                        background-color: transparent;
                        padding: 0;
                        min-width: 28px;
                        min-height: 28px;
                      "
                    />
                  </li>
                  <li>
                    <TelegramButton
                      :description="description"
                      btn-text=""
                      style="
                        background-color: transparent;
                        padding: 0;
                        min-width: 28px;
                        min-height: 28px;
                      "
                    />
                  </li>
                  <li>
                    <VkontakteButton
                      :description="description"
                      :title="course.name"
                      btn-text=""
                      style="
                        background-color: transparent;
                        padding: 0;
                        min-width: 28px;
                        min-height: 28px;
                      "
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="courses-content" v-if="!loader">
        <div class="section-frame">
          <div class="courses-content-frame">
            <div class="courses-content-information">
              <div class="courses-content-item">
                <div class="courses-content-title">
                  <i class="fa-title"></i>
                  <h3>{{ $t("description") }}</h3>
                </div>
                <div class="courses-content-body">
                  <div class="courses-content-info">
                    <p v-html="description"></p>
                  </div>
                </div>
              </div>
              <div class="courses-content-item">
                <div class="courses-content-title">
                  <i class="fa-title"></i>
                  <h3>{{ $t("course_materials") }}</h3>
                </div>
                <div class="courses-content-body" v-if="course">
                  <div
                    v-for="(item, index) in course.material"
                    :key="index"
                    class="courses-material-item"
                  >
                    <div
                      class="material-header"
                      @click="item.open = !item.open"
                    >
                      <h3>
                        <i>{{ item.name }}</i>
                        <span
                          >{{ item.lessons_count }} {{ $t("lessons") }}</span
                        >
                      </h3>
                      <span class="courses-plus"><i class="fa-title"></i></span>
                    </div>
                    <transition v-on:enter="enter" v-on:leave="leave">
                      <div v-show="item.open" class="material-body">
                        <div
                          class="material-body-item no_hover"
                          v-if="item && item.lessons.length"
                        >
                          <p class="single-complet text">
                            <i class="fa-title"></i>
                            <span>{{ $t("lessons_header") }}</span>
                          </p>
                        </div>
                        <div
                          v-for="les in item.lessons"
                          :key="les.id"
                          class="material-body-item"
                        >
                          <router-link
                            v-if="!les.is_blocked"
                            :to="`/lessons/${les.id}?id=${$route.params.id}`"
                          >
                            <p class="single-complet">
                              <svg
                                v-if="les.process_status === 'new'"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M10.75 3C10.75 2.58579 11.0858 2.25 11.5 2.25H16.5C16.9142 2.25 17.25 2.58579 17.25 3V21C17.25 21.4142 16.9142 21.75 16.5 21.75H11.5C11.0858 21.75 10.75 21.4142 10.75 21V3ZM12.25 3.75V20.25H15.75V3.75H12.25Z"
                                  fill="#CBCBDE"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M15.75 3C15.75 2.58579 16.0858 2.25 16.5 2.25H21.5C21.9142 2.25 22.25 2.58579 22.25 3V21C22.25 21.4142 21.9142 21.75 21.5 21.75H16.5C16.0858 21.75 15.75 21.4142 15.75 21V3ZM17.25 3.75V20.25H20.75V3.75H17.25Z"
                                  fill="#CBCBDE"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M3.50349 2.42778C3.54293 2.02032 3.90182 1.71975 4.30988 1.75243L9.55988 2.17289C9.7603 2.18894 9.94589 2.28479 10.075 2.43894C10.2041 2.59309 10.2659 2.79262 10.2465 2.99275L8.49651 21.0723C8.45707 21.4798 8.09819 21.7803 7.69013 21.7476L2.44013 21.3272C2.2397 21.3111 2.05412 21.2153 1.92502 21.0611C1.79592 20.907 1.73412 20.7075 1.75349 20.5073L3.50349 2.42778ZM4.92544 3.30653L3.31998 19.8929L7.07456 20.1935L8.68003 3.60722L4.92544 3.30653Z"
                                  fill="#CBCBDE"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M19 6.75C19.4142 6.75 19.75 7.08579 19.75 7.5V9C19.75 9.41421 19.4142 9.75 19 9.75C18.5858 9.75 18.25 9.41421 18.25 9V7.5C18.25 7.08579 18.5858 6.75 19 6.75Z"
                                  fill="#CBCBDE"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M14 6.75C14.4142 6.75 14.75 7.08579 14.75 7.5V9C14.75 9.41421 14.4142 9.75 14 9.75C13.5858 9.75 13.25 9.41421 13.25 9V7.5C13.25 7.08579 13.5858 6.75 14 6.75Z"
                                  fill="#CBCBDE"
                                />
                              </svg>
                              <img
                                v-if="les.process_status === 'progress'"
                                src="../../assets/images/icon/play.svg"
                                alt=""
                              />
                              <i
                                v-if="les.process_status === 'finished'"
                                class="fa-check"
                              ></i>
                              <span>{{ les.name }}</span>
                            </p>
                            <i
                              v-if="les.is_blocked"
                              class="fa-lock material-lock"
                            ></i>
                            <i
                              v-else
                              class="fa-lock-open material-lock-open"
                            ></i>
                          </router-link>
                          <div v-else>
                            <p class="single-complet">
                              <svg
                                v-if="les.process_status === 'new'"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M10.75 3C10.75 2.58579 11.0858 2.25 11.5 2.25H16.5C16.9142 2.25 17.25 2.58579 17.25 3V21C17.25 21.4142 16.9142 21.75 16.5 21.75H11.5C11.0858 21.75 10.75 21.4142 10.75 21V3ZM12.25 3.75V20.25H15.75V3.75H12.25Z"
                                  fill="#CBCBDE"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M15.75 3C15.75 2.58579 16.0858 2.25 16.5 2.25H21.5C21.9142 2.25 22.25 2.58579 22.25 3V21C22.25 21.4142 21.9142 21.75 21.5 21.75H16.5C16.0858 21.75 15.75 21.4142 15.75 21V3ZM17.25 3.75V20.25H20.75V3.75H17.25Z"
                                  fill="#CBCBDE"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M3.50349 2.42778C3.54293 2.02032 3.90182 1.71975 4.30988 1.75243L9.55988 2.17289C9.7603 2.18894 9.94589 2.28479 10.075 2.43894C10.2041 2.59309 10.2659 2.79262 10.2465 2.99275L8.49651 21.0723C8.45707 21.4798 8.09819 21.7803 7.69013 21.7476L2.44013 21.3272C2.2397 21.3111 2.05412 21.2153 1.92502 21.0611C1.79592 20.907 1.73412 20.7075 1.75349 20.5073L3.50349 2.42778ZM4.92544 3.30653L3.31998 19.8929L7.07456 20.1935L8.68003 3.60722L4.92544 3.30653Z"
                                  fill="#CBCBDE"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M19 6.75C19.4142 6.75 19.75 7.08579 19.75 7.5V9C19.75 9.41421 19.4142 9.75 19 9.75C18.5858 9.75 18.25 9.41421 18.25 9V7.5C18.25 7.08579 18.5858 6.75 19 6.75Z"
                                  fill="#CBCBDE"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M14 6.75C14.4142 6.75 14.75 7.08579 14.75 7.5V9C14.75 9.41421 14.4142 9.75 14 9.75C13.5858 9.75 13.25 9.41421 13.25 9V7.5C13.25 7.08579 13.5858 6.75 14 6.75Z"
                                  fill="#CBCBDE"
                                />
                              </svg>
                              <img
                                v-if="les.process_status === 'progress'"
                                src="../../assets/images/icon/play.svg"
                                alt=""
                              />
                              <i
                                v-if="les.process_status === 'finished'"
                                class="fa-check"
                              ></i>
                              <span>{{ les.name }}</span>
                            </p>
                            <i
                              v-if="les.is_blocked"
                              class="fa-lock material-lock"
                            ></i>
                            <i
                              v-else
                              class="fa-lock-open material-lock-open"
                            ></i>
                          </div>
                        </div>
                        <div
                          class="material-body-item no_hover"
                          v-if="item.quiz"
                        >
                          <p class="single-complet text">
                            <i class="fa-title"></i
                            ><span>{{ $t("test") }}</span>
                          </p>
                        </div>
                        <div
                          class="material-body-item"
                          v-if="item.quiz"
                          @click.prevent="
                            $router.push(
                              `/quiz/${item.quiz.slug}?id=${$route.params.id}`,
                            )
                          "
                        >
                          <p class="single-complet">
                            <i
                              class="fa-test"
                              v-if="!item.quiz.completed && !item.quiz.progress"
                            ></i>
                            <img
                              v-if="!item.quiz.completed && item.quiz.progress"
                              src="../../assets/images/icon/play.svg"
                              alt=""
                            />
                            <i v-if="item.quiz.completed" class="fa-check"></i>
                            <span>{{ item.quiz.title }}</span>
                          </p>
                          <i
                            v-if="item.quiz.is_blocked"
                            class="fa-lock material-lock"
                          ></i>
                          <i v-else class="fa-lock-open material-lock-open"></i>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <p
                    class="single-complet text"
                    style="margin-bottom: 20px"
                    v-if="course.final_quiz"
                  >
                    <i style="margin-right: 10px" class="fa-title"></i
                    ><span>{{ $t("final_test") }}</span>
                  </p>
                  <div class="courses-material-item" v-if="course.final_quiz">
                    <div
                      class="material-header"
                      :class="{ disabled: course.final_quiz.is_blocked }"
                      style="width: 100%"
                      @click.prevent="
                        $router.push(
                          `/quiz/${course.final_quiz.slug}?id=${$route.params.id}`,
                        )
                      "
                    >
                      <h3 class="single-complet">
                        <i
                          style="font-size: 12px; margin-right: 8px"
                          class="fa-test"
                          v-if="
                            !course.final_quiz.completed &&
                            !course.final_quiz.progress
                          "
                        ></i>
                        <img
                          style="font-size: 12px; margin-right: 8px"
                          v-if="
                            !course.final_quiz.completed &&
                            course.final_quiz.progress
                          "
                          src="../../assets/images/icon/play.svg"
                          alt=""
                        />
                        <i
                          style="font-size: 12px; margin-right: 8px"
                          v-if="course.final_quiz.completed"
                          class="fa-check"
                        ></i>
                        {{ course.final_quiz.title }}
                      </h3>
                      <i
                        style="margin-left: auto; margin-right: 20px"
                        v-if="course.final_quiz.is_blocked"
                        class="fa-lock material-lock"
                      ></i>
                      <i
                        style="margin-left: auto; margin-right: 20px"
                        v-else
                        class="fa-lock-open material-lock-open"
                      ></i>
                    </div>
                  </div>
                </div>
                <div class="courses-content-body" v-else>
                  <v-loader />
                </div>
              </div>
              <div class="courses-content-item">
                <div class="courses-reviews-title">
                  <div class="courses-content-title">
                    <i class="fa-title"></i>
                    <h3>{{ $t("leave_comment") }}</h3>
                  </div>
                  <a
                    href="#"
                    v-if="!is_reviews"
                    @click.prevent="ratesPush = true"
                    class="reviews-btn js-reviews-log"
                    >{{ $t("share_opinion") }}</a
                  >
                </div>
                <div class="courses-content-body" v-if="reviews">
                  <div class="average-rating">
                    <p>
                      <i>{{ $t("average_rating") }}</i>
                      <span>{{ reviews.average_rate || 0 }}</span>
                    </p>
                    <div class="average-stars">
                      <i
                        v-for="i in 5"
                        :key="i"
                        class="fa-star"
                        :class="{
                          'average-star-active':
                            i <= Math.round(reviews.average_rate),
                        }"
                      ></i>
                      <span>({{ reviews.count }})</span>
                    </div>
                  </div>
                  <div
                    class="reviews-list"
                    v-if="reviews.result && reviews.result.length"
                  >
                    <div
                      class="reviews-item"
                      v-for="(item, i) in reviews.result"
                      :key="i"
                    >
                      <div class="reviews-info">
                        <div class="reviews-name">
                          <img
                            :src="
                              item.user_image
                                ? $mediaUrl(item.user_image)
                                : require('../../assets/images/reviews-photo.png')
                            "
                            alt=""
                          />
                          <h4>{{ item.user_name }}</h4>
                          <span>
                            {{
                              item.date_after == 0
                                ? $t("today")
                                : item.date_after + " " + $t("days_ago")
                            }}
                          </span>
                        </div>
                        <div class="reviews-stars">
                          <i
                            v-for="i in 5"
                            :key="i"
                            class="fa-star"
                            :class="{ 'average-star-active': i <= item.rates }"
                          ></i>
                        </div>
                      </div>
                      <p
                        class="reviews-text"
                        v-html="$processHtml(item.desc)"
                      ></p>
                    </div>
                  </div>
                  <div class="reviews-list" v-else>
                    <div class="reviews-item">
                      <div class="reviews-info cnt">
                        <div class="reviews-name">
                          <h4>{{ $t("no_reviews") }}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <a
                    href="#"
                    v-if="!(reviews.last_page === reviews.page)"
                    class="reviews-all"
                    @click.prevent="loadMore"
                  >
                    <div>{{ $t("more_reviews") }}</div>
                    <i class="fa-arrow-line"></i
                  ></a>
                </div>
              </div>
            </div>
            <div class="courses-content-cart">
              <img
                v-if="course"
                :src="$mediaUrl(course.image_url)"
                class="courses-content-photo"
                alt=""
              />
              <v-loader v-else />
              <div class="courses-cart-info">
                <div class="courses-cart-product">
                  <!-- Pricing removed for employee training platform -->
                  <div class="courses-cart-star" v-if="reviews">
                    <i
                      v-for="i in 5"
                      :key="i"
                      class="fa-star"
                      :class="{
                        'average-star-active':
                          i <= Math.round(reviews.average_rate),
                      }"
                    ></i>
                  </div>
                  <div class="courses-cart-star" v-else>
                    <i
                      v-for="i in 5"
                      :key="i"
                      class="fa-star"
                      :class="{ 'average-star-active': i <= 0 }"
                    ></i>
                  </div>
                </div>
                <div class="courses-cart-description">
                  <h3>{{ $t("course_includes") }}</h3>
                  <ul>
                    <li>
                      <i class="fa-book"></i>{{ count_lesson }}
                      <div style="margin-left: 5px">
                        {{ $t("lessons") }}
                      </div>
                    </li>
                    <li v-if="course && course.permission">
                      <i class="fa-infinity"></i>
                      <div>{{ $t("unlimited_access") }}</div>
                    </li>
                    <li v-if="course && course.certificate">
                      <i class="fa-certificate"></i>
                      <div>{{ $t("certificate") }}</div>
                    </li>
                  </ul>
                </div>
                <!-- Course start button - no payment required -->
                <div class="courses-cart-btn" v-if="course">
                  <router-link
                    v-if="
                      course &&
                      course.material &&
                      course.material[0] &&
                      course.material[0].lessons &&
                      course.material[0].lessons[0]
                    "
                    :to="`/lessons/${course.material[0].lessons[0].id}?id=${course.id}`"
                    class="courses-add-cart"
                    ><span>{{ $t("go_to_course") }}</span>
                    <i class="fa-arrow-next"></i
                  ></router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="interest">
            <div class="page-sub-title">
              <h2>
                <i class="fa-title"></i>
                <i>{{ $t("you_may_also_like") }}</i>
              </h2>
            </div>
            <div class="courses-list" v-if="courses">
              <CoursesCard
                v-for="item in courses.result"
                :key="item.id"
                :data="item"
              />
            </div>
            <div class="courses-list loading" v-else>
              <v-loader />
            </div>
          </div>
        </div>
      </div>
      <div class="courses-content" v-else>
        <v-loader />
      </div>
    </div>
    <DeleteCoursePopup
      :reviews-event="true"
      @reviews="reviewsSubmit"
      v-if="ratesPush"
      @close="ratesPush = false"
    />
  </main>
</template>

<script>
import CoursesCard from "@/components/CoursesCard";
import Velocity from "velocity-animate";
import DeleteCoursePopup from "@/components/DeleteCoursePopup";
import TelegramButton from "vue-share-buttons/src/components/TelegramButton";
import VkontakteButton from "vue-share-buttons/src/components/VkontakteButton";
import FacebookButton from "vue-share-buttons/src/components/FacebookButton";

export default {
  data() {
    return {
      descRead: false,
      count_lesson: 0,
      hasWishlist: false,
      hasCart: null,
      ratesPush: false,
      description: "",
      loader: false,
      is_reviews: !localStorage.getItem("access"),
    };
  },
  mounted() {
    this.loader = true;
  },
  async beforeCreate() {
    await this.$store.dispatch("getCourse", this.$route.params.id);
    await this.$store.dispatch("getReviewsById", {
      id: this.$route.params.id,
      page: 1,
    });
    if (this.course) {
      this.course.material.map((e) => {
        this.count_lesson += e.lessons_count;
      });

      this.description = document.createElement("span");
      this.description.innerHTML = this.course.description;
      this.description = this.description.textContent;
      await this.$store.dispatch("getCoursesById", this.course.category_id);

      await this.hasWish();
    }
  },
  methods: {
    enter(el, done) {
      Velocity(
        el,
        "slideDown",
        {
          duration: 300,
          easing: "easeInBack",
        },
        { complete: done },
      );
    },
    leave(el, done) {
      Velocity(
        el,
        "slideUp",
        {
          duration: 300,
          easing: "easeInBack",
        },
        { complete: done },
      );
    },
    async loadMore() {
      await this.$store.dispatch("paginationReviews", {
        id: this.$route.params.id,
        page: this.reviews.page + 1,
      });
    },
    async pushWishlist(id) {
      if (localStorage.getItem("access")) {
        let obj = {
          courses: [id],
        };
        await this.$store.dispatch("addWishlist", obj);
        await this.hasWish();
      } else {
        await this.$store.commit("setError", "no-auth");
        await this.$router.push("/login");
      }
    },
    async hasWish() {
      this.loader = true;
      if (localStorage.getItem("access")) {
        await this.$store.dispatch("getWishlist");
      }
      if (this.wishlist) {
        this.wishlist.map((el) => {
          el.id === this.course.id
            ? (this.hasWishlist = true)
            : (this.hasWishlist = false);
        });
      }
      this.loader = false;
    },
    async reviewsSubmit(e) {
      let obj = {
        rates: e.rates,
        desc: e.desc,
        course_id: this.$route.params.id,
      };
      await this.$store.dispatch("postReviews", obj);
      await this.$store.dispatch("getReviewsById", {
        id: this.$route.params.id,
        page: 1,
      });
      // await this.$store.dispatch('getCourse', this.$route.params.id)
    },
  },
  computed: {
    course() {
      return this.$store.getters.getCourse;
    },
    courses() {
      return this.$store.getters.getCourses;
    },
    reviews() {
      return this.$store.getters.getReviews;
    },
    wishlist() {
      return this.$store.getters.getWishlist;
    },
    lang() {
      return this.$store.getters.lang;
    },
  },
  components: {
    CoursesCard,
    DeleteCoursePopup,
    VkontakteButton,
    FacebookButton,
    TelegramButton,
  },
};
</script>
